export const MainMenuSectionEnum = {
    GetStarted: "get-started",
    Reports: "reports",
    Orders: "orders",
    Customers: "customers",
    Timesheets: "timesheets",
    Locations: "locations",
    ItemsMenus: "items-menus",
    BusinessDetails: "business-details",
    Marketing: "marketing",
    Inventory: "inventory",
    Settings: "settings",
    Console: "console-settings",
    Streaming: "streaming",
    // Old sidemenu agendas, to be removed:
    Management: "management",
}

export type MainMenuSection = (typeof MainMenuSectionEnum)[keyof typeof MainMenuSectionEnum]

export const MainMenuAgendaEnum = {
    GetStarted: "get-started",
    SummaryReport: "summary",
    ExtensiveReports: "extensiveReports",
    BreakdownByPaymentReport: "breakdownByPaymentType",
    SalesByItemsReport: "salesByItems",
    SpecialPricingReport: "specialPricing",
    VoidsReport: "voids",
    CashRegisterReport: "cash",
    PreparationTime: "preparationTime",
    AnalyticsReport: "analytics",
    CustomerReport: "customers",
    CustomersFeedback: "customersFeedback",
    OrdersReport: "orders",
    TransactionsReport: "transactions",
    TimesheetReport: "timesheet",
    Locations: "locations",
    ItemsAndCategories: "menu",
    SalesInput: "sales-input",
    Schematized: "schematized",
    TaxationOld: "taxation-old",
    Taxation: "taxation",
    Pricing: "pricing",
    Assignments: "assignments",
    Employees: "employees",
    Roles: "roles",
    FigQRSettings: "figqr-settings",
    LoyaltyProgram: "loyalty-program",
    Promotions: "promotions",
    CardPrograms: "card-programs",
    Inventory: "inventory",
    GeneralSettings: "settings",
    ReceiptSettings: "receipt-settings",
    PaymentsSettings: "payment-settings",
    MakeItButterSettings: "make-it-butter-settings",
    Domains: "domains",
    DeliverySettings: "delivery-settings",
    ConsoleSettings: "console-settings",
    OrganizationAccounts: "organization-accounts",
    FeatureUsage: "feature-usage",
    SelectAccountOrganization: "select-account",
    Login: "login",
    SignUp: "sign-up",
}

export type MainMenuAgenda = (typeof MainMenuAgendaEnum)[keyof typeof MainMenuAgendaEnum]
